import UnfoldRuntime from "../language/parse";
import EthereumWalletContext from "../language/EthereumWalletContext";
import { useState } from "react";
import Queries from "../language/Queries.js";

const ScriptingCard = ({ disabled, address, onResultReady }) => {
    const [code, setCode] = useState("");
    const [error, setError] = useState("");

    const runScript = async () => {
        const walletContext = new EthereumWalletContext(address);
        const runtime = new UnfoldRuntime(code, walletContext);

        await runtime.setup();
        console.log(runtime.ast);
        await runtime.execute();

        console.log(runtime.result());
        onResultReady(runtime.result());
        setError("");
    }

    const run = async () => {
        try {
            await runScript();
        } catch (e) {
            console.log(e);
            setError(e);
        }
    }

    const toEtherscan = () => {
        window.open("https://etherscan.io/address/" + address);
    }

    const handleTyping = (text) => {
        setCode(text.target.value);
    }

    Array.prototype.sample = function () {
        return this[Math.floor(Math.random() * this.length)];
    }

    const generateExample = () => {
        const example = Queries.sample();
        console.log(example);
        setCode(example);

    }

    return (
        <div className={"card" + (disabled ? " disabled" : "")}>
            Great! You can now write a wallet query using Unfold.<br></br>

            {address && <div className="connected">Querying <span className="validAddress" onClick={toEtherscan}>{address}</span></div>}

            <textarea
                className="scriptingArea"
                onChange={handleTyping}
                value={code}
            />
            {error && <p className="errorMessage">{error}</p>}
            <p className="generateExample" onClick={generateExample}>&#8635; Generate Example Query</p>

            Once you're done, let's run the script.< br ></br >

            <button className="secondaryButton run" onClick={run}>&#9658; Run</button><br></br>
        </div >
    );
}

export default ScriptingCard;